/**
 * Wipe previous Sort / Check working tables before loading a folder's
 * saved snapshot (Retest / Review / auto-open).
 *
 * Without this, Retest of folder B can leave folder A's Check rows on
 * screen when B has no assessment snapshot (import 404 skips the wipe
 * that only runs inside a successful import). Browser caches of the
 * Tables tab + Check session state can clash the same way.
 */

export const CLEAR_WORKING_TABLES_EVENT = 'fastgrader:clear-working-tables';
export const WORKING_TABLES_RELOADED_EVENT = 'fastgrader:working-tables-reloaded';

const LOCAL_KEYS = [
  'tableData',
  'assessmentProcessing',
  'assessmentProgress',
  'assessmentSessionId',
  'assessmentProgressDetails',
  'recheckingResultIds'
];

export function clearWorkingTableLocalStorage() {
  for (const key of LOCAL_KEYS) {
    try { localStorage.removeItem(key); } catch { /* ignore */ }
  }
  try {
    window.dispatchEvent(new CustomEvent(CLEAR_WORKING_TABLES_EVENT));
  } catch { /* ignore */ }
}

/**
 * Delete this user's live Sort + Check working copies on the server.
 * Safe to call even when one endpoint fails — best-effort wipe.
 */
export async function clearServerWorkingTables(apiBase, token, folderPath) {
  const headers = { Authorization: `Bearer ${token}` };
  const analyzeUrl = folderPath
    ? `${apiBase}/analyze/results?folder_path=${encodeURIComponent(folderPath)}`
    : `${apiBase}/analyze/results`;
  const results = await Promise.allSettled([
    fetch(analyzeUrl, { method: 'DELETE', headers }),
    fetch(`${apiBase}/assess/results`, { method: 'DELETE', headers })
  ]);
  for (const r of results) {
    if (r.status === 'rejected') {
      console.warn('[clearWorkingTables] server wipe failed:', r.reason);
    } else if (r.value && !r.value.ok) {
      console.warn('[clearWorkingTables] server wipe non-ok:', r.value.status);
    }
  }
}

/** Full pre-load wipe: browser cache + server working copies. */
export async function clearAllWorkingTables(apiBase, token, folderPath) {
  clearWorkingTableLocalStorage();
  if (apiBase && token) {
    await clearServerWorkingTables(apiBase, token, folderPath);
  }
}

export function notifyWorkingTablesReloaded(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent(WORKING_TABLES_RELOADED_EVENT, { detail }));
  } catch { /* ignore */ }
}
